import styled from 'styled-components';

export const HistoryGridWrapper = styled.div`
  border-radius: 8px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.quaternaryBackground};
  tr {
    white-space: normal;
  }
`;
